import React, { useCallback, useContext, useEffect, useState } from "react";
import Container from "src/layout/Container";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CardMedia,
} from "@material-ui/core";
import { UsersData } from "src/ContextAPI";
import axios from "axios";
import Notify from "src/notification/Notify";

const Receivable = () => {
  const { users } = useContext(UsersData);
  const [receivable, setReceivable] = useState({ data: [], ready: false });
  const [totalReceivable, setTotalReceivable] = useState(null);

  const getAllReceivable = useCallback(async () => {
    var params = { user_id: users.user_id, management_id: users.management_id };
    try {
      let response = await axios.get("accounting/get/receivable-list", {
        params,
      });
      const data = response.data;
      setReceivable({ data, ready: true });
      setTotalReceivable(calculateReceivable(data));
    } catch (error) {
      console.log("error: ", error);
    }
  }, [users]);

  const calculateReceivable = (data) => {
    var total = 0;
    for (let x = 0; x < data.length; x++) {
      total += parseFloat(data[x].bill_amount) * parseFloat(1);
    }
    return total;
  };

  useEffect(() => {
    if (users.management_name !== "BMCDC HQ") {
      getAllReceivable();
    }
    // eslint-disable-next-line
  }, [getAllReceivable]);

  return (
    <>
      <Container
        breadcrumbs={{
          enable: true,
          current: "Receivable",
          items: [{ name: "Dashboard", path: "/sph/app" }],
        }}
        title={
          <Box display="flex">
            <Box flexGrow={1}>Receivable</Box>
            <Box>
              <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
                Total Receivable: P {Notify.convertToNumber(totalReceivable)}
              </Typography>
            </Box>
          </Box>
        }
      >
        {receivable.ready ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Patient</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Company</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Discount</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Total</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {receivable.ready ? (
                  receivable.data.length > 0 ? (
                    receivable.data.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {Notify.createdAt(data.created_at)}
                        </TableCell>
                        <TableCell>{data.patient_name}</TableCell>
                        <TableCell>{data.companyName}</TableCell>
                        <TableCell align="right">
                          {Notify.convertToNumber(data.discount)}
                        </TableCell>
                        <TableCell align="right">
                          {Notify.convertToNumber(data.bill_amount)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5}>
                        <Typography color="secondary">
                          No record found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography color="primary">
                        Loading, please wait...
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <RenderSelectReceivable />
        )}
      </Container>
    </>
  );
};

export default Receivable;

const RenderSelectReceivable = () => (
  <Box align="center">
    <CardMedia
      component="img"
      src={"/gtc-logo.png"}
      alt=""
      style={{ width: 270 }}
    />

    <Typography color="secondary" variant="h3">
      NO BRANCH SELECTED
    </Typography>

    <Typography color="secondary" variant="h6">
      Select branch in the list to view details.
    </Typography>
  </Box>
);
